// A whole CPU taxi driver: picks fares, drives to them, delivers, chooses upgrades.

import { BotDriver } from './bot';
import type { Navigator } from './nav';
import type { Match, PlayerState } from './match';
import type { Fare } from './fares';

export class BotPlayer {
  readonly driver: BotDriver;
  private target: Fare | null = null;
  private decideAt = 0;
  constructor(readonly match: Match, readonly pid: string, nav: Navigator, skill = 0.7, readonly rng = Math.random) {
    this.driver = new BotDriver(nav, { skill });
  }

  get player(): PlayerState | undefined { return this.match.players.get(this.pid); }

  step(dt: number): void {
    const p = this.player; if (!p) return;
    const m = this.match;
    // upgrades: take the rarest card, or skip if nothing useful
    if (p.offer) {
      const order = { legendary: 3, epic: 2, rare: 1, common: 0 } as const;
      const best = [...p.offer.cards].sort((a, b) => order[b.rarity] - order[a.rarity])[0];
      if (best) m.chooseUpgrade(p.id, best.id); else m.skipOffer(p.id);
    }
    if (p.respawnAt != null || m.phase !== 'playing') { this.driver.clearGoal(); this.target = null; p.input.brake = 1; return; }
    if (m.time >= this.decideAt) {
      this.decideAt = m.time + 1;
      if (p.riding.length) {
        const f = p.riding[0]; this.driver.setGoal(f.dest.x, f.dest.z); this.target = f;
      } else {
        // nearest waiting fare, slight preference for richer ones
        let best: Fare | null = null, bs = Infinity;
        for (const f of m.fares) {
          if (f.state !== 'waiting') continue;
          const d = Math.hypot(f.pickup.x - p.car.x, f.pickup.z - p.car.z) - f.base * 0.5;
          if (d < bs) { bs = d; best = f; }
        }
        if (best) { this.driver.setGoal(best.pickup.x, best.pickup.z); this.target = best; }
        else this.driver.clearGoal();
      }
      if (this.target && this.target.state === 'waiting' && this.target.rider) this.target = null;
    }
    const inp = this.driver.step(p.car, dt);
    p.input.steer = inp.steer; p.input.brake = inp.brake; p.input.throttle = inp.throttle;
    p.input.nitro = p.perks.nitro && Math.abs(p.car.speed) > 12 && Math.abs(inp.steer) < 0.15;
  }
}
